import classnames from 'classnames/bind'
import { AnimatePresence, motion } from 'framer-motion'
import React, { useRef } from 'react'

import { useIsomorphicLayoutEffect } from '@unlikelystudio/react-hooks'

import useUpdateLayoutEffect from '~/hooks/useUpdateLayoutEffect'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type LineThemes =
  | 'primary'
  | 'secondary'
  | 'black'
  | 'manatee'
  | 'inherit'
export interface LineCenterProps {
  className?: string
  theme?: LineThemes
  thickness?: 1 | 2
  isVisible?: boolean
  initialLineState?: 'underlined' | 'none'
}
/**
 * Line component
 * @param props
 * @returns Component
 */
function LineCenter({
  className,
  theme,
  isVisible,
  initialLineState,
  thickness,
}: LineCenterProps) {
  return (
    <span
      style={{ height: `${thickness ?? 1}px` }}
      className={cx(className, css.LineCenter, initialLineState, {
        [`theme-${theme}`]: theme,
      })}>
      <AnimatePresence>
        {(initialLineState === 'underlined' || isVisible) && (
          <motion.span
            className={css.lineProgress}
            initial={{ scaleX: 0 }}
            animate={{
              scaleX: 1,
            }}
            exit={{ scaleX: 0 }}
            transition={{ ease: [0.19, 1, 0.22, 1], duration: 0.3 }}
          />
        )}
      </AnimatePresence>
    </span>
  )
}

LineCenter.defaultProps = {
  theme: 'inherit',
  initialLineState: 'none',
}

export default LineCenter
